"use client";
import React, { useEffect } from "react";

import { disableScroll, enableScroll } from "@stadium/helpers/animate";
import defaultStyles from "./main.module.scss";

type ModalProps = {
  // eslint-disable-next-line no-unused-vars
  closeModal?: (event?: React.MouseEvent<any, MouseEvent>) => any;
  className?: string;
  styles?: ModularStyles;
  stopScroll?: boolean;
  mobileBottomDrawer?: boolean;
  newModal?: boolean;
  closeOnEscape?: boolean;
  children?: React.ReactNode;
  // eslint-disable-next-line no-unused-vars
  onClick?: (event?: React.MouseEvent<any, MouseEvent>) => any;
  addTopMargin?: boolean;
};

const Modal: React.FC<ModalProps> = ({
  children = "",
  closeModal,
  className = "",
  styles = defaultStyles,
  stopScroll = true,
  mobileBottomDrawer = false,
  newModal = false,
  closeOnEscape = true,
  onClick,
  addTopMargin = true,
}) => {
  useEffect(() => {
    if (stopScroll) {
      disableScroll(document.body, { addTopMargin });
      return () => {
        enableScroll(document.body);
      };
    }
  }, []);

  useEffect(() => {
    if (closeOnEscape) {
      const handleEscape = (event) => {
        if (event.key === "Escape") {
          closeModal?.();
        }
      };

      window.addEventListener("keydown", handleEscape);
      return () => window.removeEventListener("keydown", handleEscape);
    }
  }, []);

  return (
    <>
      <div
        className={`${styles.modal} ${styles.fade} ${styles.show} ${className} ${
          mobileBottomDrawer ? styles.modalMobileBottom : ""
        } ${newModal ? styles.newModalStyle : styles.oldModal}`}
        aria-hidden="false"
        onClick={onClick}
        data-acsb-overlay="popup"
      >
        {children}
        <div
          className={`${styles["modal-backdrop"]} ${styles.fade} ${styles.show}`}
          onClick={closeModal || null}
        />
      </div>
    </>
  );
};

export default Modal;
